<template>
  <div>

    <pageTable ref="table"
               :key="tableKey"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :defaultPageSize="20"
               :pageSizeOptions="[20,50,100]"
               :onSortChange="sortChange"
               tableApi="admin/gas/getOilStation"
    >
      <template v-slot:searchFormItem>


            <FormItem prop="station_id">
          <Input type="text" v-model="searchData.station_id" placeholder="站点id" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="油站名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="salesman">
          <Input type="text" v-model="searchData.salesman" placeholder="业务员" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="type">
          <Select v-model="searchData.type" placeholder="类型" clearable>
            <Option value="2">油车</Option>
            <Option value="3">撬装</Option>
            <Option value="4">加油站</Option>
          </Select>
        </FormItem>
        <FormItem prop="station_type">
          <Select v-model="searchData.station_type" placeholder="站点类型" clearable>
            <Option value="oil_station">柴油站点</Option>
            <Option value="lng_station">LNG气站</Option>
          </Select>
        </FormItem>
             <FormItem prop="is_repeat">
          <Select v-model="searchData.is_repeat" placeholder="是否重复" clearable>
            <Option value="0">全部</Option>
            <Option value="1">重复</Option>
          </Select>
        </FormItem>
        <FormItem prop="is_bill">
          <Select v-model="searchData.is_bill" placeholder="业务类型" clearable>
            <Option value="1">A型</Option>
            <Option value="0">B型</Option>
          </Select>
        </FormItem>
        <FormItem prop="platform">
          <Select v-model="searchData.platform" placeholder="渠道" clearable>
            <Option v-for="(item,key) in platform" :value="item.id" :key="key">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="is_del">
          <Select v-model="searchData.status" placeholder="状态" clearable>
            <Option value="1">正常</Option>
            <Option value="3">重复站已禁用</Option>
            <Option value="-1">禁用</Option>
            <Option value="">全部</Option>
          </Select>
        </FormItem>
        <FormItem prop="provinceDone">
          <Select v-model="searchData.provinceDone" placeholder="省市区完整">
            <Option value="">全部</Option>
            <Option value="-1">不完整</Option>
            <Option value="1">完整</Option>
          </Select>
        </FormItem>
        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" @on-change="timeChange" placeholder="注册时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="editStationPrice">对外价格修改</Button>
        </FormItem>
        <FormItem>
          <Button type="warning" @click="exportStation">导出</Button>
        </FormItem>

        <!-- <FormItem prop="piaodian">
          <Input type="text" v-model="searchData.piaodian" placeholder="票点" class="lx-search-item"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="setPiaodian">批量修改</Button>
        </FormItem> -->
        <FormItem prop="selectedType">

     <Select v-model="searchData.selectedType" @on-change="onTypeChange">
      <Option value="1">柴油票点 A型</Option>
      <Option value="2">LNG票点 A型</Option>
      <Option value="3">柴油票点 B型</Option>
      <Option value="4">LNG票点 B型</Option>
    </Select>
        </FormItem>

            <FormItem prop="piaodian">
        <Input v-model="searchData.piaodian" placeholder="票点" />
            </FormItem>

       <FormItem>
          <Button type="primary" @click="setPiaodian">批量修改</Button>
        </FormItem> 

        <FormItem>
          <Button type="warning" @click="showSetNdrcPrice">挂牌价设置</Button>
        </FormItem>
        <FormItem>
          <Button v-if="searchData.sortKey" type="error" ghost @click="resetSort" icon="ios-close-circle-outline">重置排序</Button>
        </FormItem>
      </template>
    </pageTable>
    <!-- 新增：重复站点详情弹窗 -->
    <Modal
      v-model="duplicateModal.isShow"
      :title="'重复站点 - ' + (duplicateModal.station_id || '')"
      :loading="duplicateModal.loading"
      @on-cancel="closeDuplicateModal"
      width="900"
    >
      <div v-if="duplicateModal.loading" style="text-align:center;padding:20px">加载中...</div>
      <div v-else>
        <div v-if="duplicateModal.list && duplicateModal.list.length">
          <Table :columns="dupColumns" :data="duplicateModal.list" :bordered="false" />
        </div>
        <div v-else style="padding:10px">未发现重复站点</div>
      </div>
    </Modal>
    <stationEditForm v-if="showStationEdit"
               :show-edit="showStationEdit"
               :station_id="editStationId"
               ref="editModel"
               @cancel-edit="hideEdit()"
    >
    </stationEditForm>

    <userEditForm v-if="showUserDetail"
                     :show-edit="showUserDetail"
                     :user_id="editUserId"
                     ref="editModel"
                     @cancel-edit="showUserDetail=false"
    >
    </userEditForm>

    <Drawer title="油站详情" width="900"
            :value="showAddForm"
            :mask-closable="true" @on-close="cancelAddStation">
      <addStationForm v-if="showAddForm"></addStationForm>
    </Drawer>


    <Modal
            v-model="editProvinceForm.isShow"
            :title="editProvinceForm.title"
            :loading="editProvinceForm.isLoading"
            @on-ok="doEditProvince"
            @on-cancel="cancelEditProvince">
      <p>原省市区：{{editProvinceForm.oldAddress}}</p>
      <Form ref="rechargeForm" :label-width="100" :model="editProvinceForm">
        <Cascader :data="provinceData" v-model="editProvinceForm.province"></Cascader>
      </Form>
    </Modal>

    <!--<Modal
            v-model="rechargeModal"
            :title="rechargeModalTitle"
            :loading="loadingRechargeModal"
            @on-ok="doRecharge"
            @on-cancel="cancelRechargeModal">
      <Form ref="rechargeForm" :label-width="100" :model="rechargeForm">
        <FormItem label="充值金额" prop="amount">
          <Input v-model="rechargeForm.amount" placeholder="请输入整数,正数添加余额，负数扣除余额" maxlength="100"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="rechargeForm.remark" placeholder="" maxlength="50"></Input>
        </FormItem>
      </Form>
    </Modal>-->

<!--    挂牌价设置-->
    <Modal
            v-model="ndrcPriceModel.isShow"
            title="定时设置挂牌价"
            :loading="ndrcPriceModel.isLoading"
            @on-ok="setNdrcPrice"
            @on-cancel="ndrcPriceModel.isShow=false">
      <p>最近设置 {{ndrcPriceModel.prevTime}} --- {{ndrcPriceModel.prevPrice}}</p>
      <Form ref="ndrcPriceForm" :label-width="100" :model="ndrcPriceModel">
        <FormItem label="挂牌价" prop="price">
          <Input v-model="ndrcPriceModel.price" placeholder="最多两位小数点"></Input>
        </FormItem>
        <FormItem label="设置时间" prop="dotime">
          <DatePicker type="datetime" v-model="ndrcPriceModel.dotime" style="width: 200px"></DatePicker>
        </FormItem>
      </Form>
    </Modal>


    <Drawer :title="stockLogDrawer.title" width="900"
            :value="stockLogDrawer.isShow"
            :mask-closable="true"
            @on-close="stockLogDrawer.isShow=false">
      <stockLog :station-id="stockLogDrawer.station_id" v-if="stockLogDrawer.isShow"></stockLog>
    </Drawer>



    <!-- 新增：油品管理弹窗 -->
    <Modal
      v-model="productModal.isShow"
      :title="productModal.title"
      :loading="productModal.isLoading"
      @on-cancel="cancelProductModal"
      width="980"
    >
      <div v-if="productModal.isLoading" style="text-align:center;padding:20px">加载中...</div>
      <div v-else>
        <!-- 列表：行内可编辑（不再使用下拉选择，直接展示5行） -->
        <Table :columns="productColumns" :data="productModal.list" :border="true" />
      </div>
    </Modal>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import stationEditForm from "./edit";
  import userEditForm from "../user/edit";
  import addStationForm from "./addStation";
  import XLSX from 'xlsx'
  import stockLog from "./stockLog";
  import axios from 'axios';
  export default {
    name: "ty",
    components:{pageTable,stationEditForm,userEditForm,addStationForm,stockLog},
    data() {
      return {
        editUserId:0,     //编辑的ID
        showUserDetail:false,
        showStationEdit:false,
        editStationId:0,
        showAddForm:false,
        ticket_point_lng:'',//LNG票点
        ticket_point_oil:'',//柴油票点
        ticket_point_lng_b:'',//LNG成本B票点
        ticket_point_oil_b:'',//柴油成本B票点
        tableKey: 0,  // 用于强制重新渲染表格
        searchData: {
          gas_name: '',
          station_id:'',
          create_time:'',
          self_support:'',
          platform:'',
          provinceDone:'',
          piaodian:'',
          status:'1',
          is_repeat:'0',
          selectedType: '1',
          sortKey:'',
          sortType:'',
        },
        tableColumn: [
          {title: 'ID',key: 'station_id',align: "center",width:100,render:(h,params)=>{
                return h('div',[
                  h('p',params.row.station_id),
                  h('Tag',{props:{color:'orange'}},params.row.platform),
                ])
            }},
          {title: '油站名称',key: 'gas_name',minWidth:160,align: "left",render:(h,params)=>{
                  let content  =[];
                 if(params.row.is_repeat==1){
                  content.push( h('Tag',{props:{color:'red'}},'重复'))
                 }
                content.push( h('Tag',{props:{color:'orange'}},params.row.station_type_name))
                content.push( h('span',params.row.gas_name))
            
              return h('div',content)
            }},
          {title: '省市区',width:160,align: "left",render:(h,params)=>{
            return h('div',{
              on:{
                click:()=>{
                  this.editProvince(params.row)
                }
              }
            },`${params.row.province_name}/${params.row.city_name}/${params.row.county_name}`)
            }},
          {title: '是否推平台',width:160,align: "left",render:(h,params)=>{
              return params.row.is_use_platform == 1 ? h('Tag', {props: {color: 'success'}}, '不推平台') : null
            }},
          // {title: '剩余升数(L)',key: 'litre_balance',align: "center",width:120,render:(h,params)=>{
          //     return h('div',[
          //       h('p',[
          //         h('a',{
          //           on:{click:()=> {this.showStockLogDrawer(params.row)}}
          //         },params.row.litre_balance)
          //       ]),
          //       h('p',params.row.is_show_balance),
          //
          //     ])
          //   }},
          /*{title: '开通库存',align: "center",render:(h,params)=>{
              return h('i-switch',{
                props:{
                  size:'large',
                  'true-color':'#13ce66',
                  'false-color':"#ff4949",
                  value:params.row.is_open_stock === 1,
                },
                scopedSlots:{
                  open:()=>h('span','开启'),
                  close:()=>h('span','关闭')
                },
                on:{
                  'on-change':(e)=>{
                    console.log(e)
                    this.setOpenStock(params.row,e)
                  }
                }
              })
            }},*/
          /*{title: '联系方式',key:'contact_user',align: "center",width:140,render:(h,params)=>{
              return h('div',[
                h('p',params.row.contact_user),
                h('p',params.row.contact_mobile),
              ])
            }},*/
          /*{title: '对外价格',key: 'price',align: "center",render:(h,params)=>{
              return h('div',params.row.price)
            }},*/
          {title: '类型',key: 'price2',align: "center",width:100,sortable: 'custom',renderHeader:(h,params)=>{
              return h('div',{
                style:{
                  cursor:'pointer'
                },
                attrs:{
                  title:'点击排序'
                }
              },'类型')
            },render:(h,params)=>{
            if (params.row.is_bill== 0){
              return h('div',[
                h('p',params.row.no_bill_price),
                h('Tag',{props:{color:'orange'}},'B型'),
              ])
            }else{
              return h('div',[
                h('p',params.row.price2),
                h('Tag',{props:{color:'orange'}},'A型'),
              ])
            }
            }},
          {title: '站点价格',align: "center",width:170,render:(h,params)=>{
              return h('div',[
                h('p',`油机价: ${params.row.station_price}`),
                h('p',`挂牌价: ${params.row.ndrc_price}`),
              ])
            }},
          {title: '上次修改时间',key: 'update_time',width:170,align: "center",sortable: 'custom',renderHeader:(h,params)=>{
              return h('div',{
                style:{
                  cursor:'pointer'
                },
                attrs:{
                  title:'点击排序'
                }
              },'上次修改时间')
            }},
          /*{title: '是否带票',align: "center",render:(h,params)=>{
              return h('i-switch',{
                props:{
                  size:'large',
                  'true-color':'#13ce66',
                  'false-color':"#ff4949",
                  value:params.row.is_bill === 1,
                },
                scopedSlots:{
                  open:()=>h('span','带票'),
                  close:()=>h('span','不带')
                },
                on:{
                  'on-change':(e)=>{
                    this.setIsBill(params.row,e)
                  }
                }
              })
            }},*/
          /*{title: '是否壳牌支付',align: "center",render:(h,params)=>{
              return h('i-switch',{
                props:{
                  size:'large',
                  'true-color':'#13ce66',
                  'false-color':"#ff4949",
                  value:params.row.is_need_qppay === 1,
                },
                scopedSlots:{
                  open:()=>h('span','是的'),
                  close:()=>h('span','不是')
                },
                on:{
                  'on-change':(e)=>{
                    this.setIsNeedQppay(params.row,e)
                  }
                }
              })
            }},*/
          {title: '业务员',key: 'salesman',align: "center",width:100,},
          {title: '待结算',key: 'unsettle_amount',align: "center",width:100,},
          // {title: '注册时间',key:'create_time',align: "center"},
          {
            title: '状态', align: "center", width: 120, render: (h, params) => {
              let status = parseInt(params.row.gas_status)
              let content = [];
              if (status === 1) {
                content.push(h('span', '正常'))
              } else if (status === 3) {
                // 状态为"重复站已禁用"时，显示“详情”按钮，点击查看重复站点列表
                content.push(h('span', { style: { color: 'orange' } }, '重复站已禁用'))
              } else if (status === 5) {
                content.push(h('span', { style: { color: 'blue' } }, '待审核'))
              } else {
                content.push(h('span', { style: { color: 'red' } }, '禁用'))
              }
              // content.push(h('Icon',
              //   {
              //     props: { type: 'ios-repeat', size: '24', color: 'red' },
              //     style: { marginLeft: '5px' },
              //     on: {
              //       click: () => { this.changeStationStatus(params.row.station_id, params.row.gas_status) }
              //     }
              //   }
              // ))
              if (params.row.is_repeat) {
                content.push(
                  h('Button', {
                    props: { type: 'primary', size: 'small' },
                    style: { marginLeft: '8px' },
                    on: { click: () => { this.showDuplicates(params.row.station_id) } }
                  }, '重复站详情')
                )
              }
              return h('div', content)
            }
          },
          {title: '是否核销',align: "center",width:100,render:(h,params)=>{
              return h('span',params.row.verification_tag===1 ? '需核销' : '')
            }},
          {title: 'Tips',key: 'tips',align: "left",width:140},
          {title: '操作',fixed:'right',width:140,render:(h,params)=>{
            // 统一构建按钮数组，条件渲染“油品”按钮（仅油站）
            let btns = [
              h('Button',{props:{type:'primary',size:'small'},on:{click:()=>{this.showDetail(params.row.station_id)}}},'查看'),
              h('Button',{props:{type:'error',size:'small'}, style:{marginLeft:'5px'}, on:{click:()=>{this.del(params.row)}}},'删除'),
              h('Button',{props:{type:'warning',size:'small'}, style:{marginTop:'3px'}, on:{click:()=>{this.updateStation(params.row.station_id,params.row.gas_id , params.row.platform,params.row.station_type)}}},'更新'),
            ];
            // 仅当为油站类型时显示“油品”按钮
            // if(params.row.station_type === 'oil_station'){
            //   btns.push(
            //     h('Button',{props:{type:'info',size:'small'}, style:{marginTop:'3px', marginLeft:'5px'}, on:{click:()=>{this.showProducts(params.row.station_id, params.row.gas_name)}}},'油品')
            //   );
            // }
            return h('div',btns)
          }},
        ],
        tableData: [],
        stationChangePrice:'',
        platform:[{id:'自营',name:'自营'}],
        editProvinceForm:{
          isShow:false,
          isLoading:false,
          title:'',
          station_id:0,
          oldAddress:'',
          province:[]
        },
        provinceData:[],
        ndrcPriceModel:{
          isShow:false,
          isLoading:true,
          prevTime:'',
          prevPrice:'',
          price:'',
          dotime:''
        },
        stockLogDrawer:{
          isShow:false,
          station_id:0,
          title:'',
        },
        // 新增：重复站点弹窗数据
        duplicateModal: {
          isShow: false,
          loading: false,
          station_id: null,
          list: []
        },

        // 新增：用于 Table 显示重复站点的列定义
        dupColumns: [
          { title: '站点ID', key: 'station_id', align: 'center', width: 100 },
          { title: '油站名称', key: 'gas_name', align: 'left', minWidth: 150 },
          { title: '平台', key: 'platform', align: 'center', width: 120 },
          { title: '状态', key: 'gas_status', align: 'center', width: 100 },
          { 
            title: '价格(元)', 
            key: 'price2', 
            align: 'right', 
            width: 120,
            render: (h, params) => {
              const row = params.row;
              const isLowestPrice = row.is_lowest_price_flag === 1;
              return h('span', { 
                style: { 
                  color: isLowestPrice ? '#ff4d4f' : '',
                  fontWeight: isLowestPrice ? '600' : '500',
                  fontSize: '14px'
                }
              }, `¥${row.price2}`);
            }
          },
          {
            title: '组内最低价',
            key: 'lowest_price',
            align: 'right',
            width: 120,
            render: (h, params) => {
              return h('span', params.row.lowest_price ? `¥${params.row.lowest_price}` : '-');
            }
          }
        ],

        // 新增：油品管理状态
        productModal: {
          isShow: false,
          isLoading: false,
          station_id: 0,
          title: '',
          list: [],
        },

        // 油品下拉选项（要求的列表，作为默认回退）
        oilOptions: [
          { id: "0#", label: '0#柴油' },
          { id: "-10#", label: '-10#柴油' },
          { id: "-20#", label: '-20#柴油' },
          { id: "-35#", label: '-35#柴油' },
          { id: "-50#", label: '-50#柴油' },
        ],

        // 用于渲染的产品列（调整：不显示 id，第一列为 oil_no_name 的静态文本）
        productColumns: [
          { title: '油品', key: 'oil_no_name', align: 'left', width: 160, render: (h, params) => {
              return h('span', params.row.oil_no_name || '')
            }},
          { title: '启用', key: 'enabled', align: 'center', width: 100, render: (h, params) => {
              return h('i-switch', {
                props: {
                  value: !!params.row.enabled,
                  size: 'small',
                  'true-color': '#13ce66',
                  'false-color': '#ff4949'
                },
                on: {
                  'on-change': (val) => { this.toggleProductEnable(params.row, val) }
                }
              })
            }},
          { title: '对外价格', key: 'price', align: 'center', width: 100, render: (h, params) => {
              return h('Input', {
                props: { value: params.row.price, disabled: !params.row.enabled },
                on: { input: (val) => { params.row.price = val } }
              })
            }},
          { title: '对内价格', key: 'price2', align: 'center', width: 100, render: (h, params) => {
              return h('Input', {
                props: { value: params.row.price2, disabled: !params.row.enabled },
                on: { input: (val) => { params.row.price2 = val } }
              })
            }},
          { title: '油机价', key: 'station_price', align: 'center', width: 100, render: (h, params) => {
              return h('Input', {
                props: { value: params.row.station_price, disabled: !params.row.enabled },
                on: { input: (val) => { params.row.station_price = val } }
              })
            }},
          { title: '不带票价格', key: 'no_bill_price', align: 'center', width: 120, render: (h, params) => {
              return h('Input', {
                props: { value: params.row.no_bill_price, disabled: !params.row.enabled },
                on: { input: (val) => { params.row.no_bill_price = val } }
              })
            }},
          { title: '挂牌价', key: 'ndrc_price', align: 'center', width: 100, render: (h, params) => {
              return h('Input', {
                props: { value: params.row.ndrc_price, disabled: !params.row.enabled },
                on: { input: (val) => { params.row.ndrc_price = val } }
              })
            }},
          { title: '操作', align: 'center', width: 160, render: (h, params) => {
              return h('div', [
                h('Button', { props: { type: 'primary', size: 'small' }, on: { click: () => { this.saveRow(params.row) } } }, '保存'),
              ])
            }
          }
        ],
      }
    },
    computed: {
      // 判断是否存在异常低价站点
      hasLowPriceStation() {
        return this.duplicateModal.list && this.duplicateModal.list.some(s => s.is_lowest_price_flag === 1);
      }
    },
    methods: {
      editSuccess(){
        this.showAddForm = false;
        this.$refs.table.getLists();
      },
      showDetail(station_id){
        this.showStationEdit = true
        this.editStationId = station_id
      },
      showStockLogDrawer(info){
        this.stockLogDrawer.isShow = true
        this.stockLogDrawer.station_id = info.station_id
        this.stockLogDrawer.title = info.gas_name
      },
      showUserDetailPage(user_id){
        this.showUserDetail = true
        this.editUserId = user_id
      },
      reloadDetail(user_id){
        this.showUserDetail = false
        this.$nextTick(()=>{
          this.showUserDetailPage(user_id)
        })
      },
      showAddStation(){
        this.showAddForm = true
      },
      cancelAddStation(){
        this.showAddForm = false;
      },
      onTypeChange(value) {
        // 根据选择的类型改变输入框的值
        
        switch (value) {

          case '1': //柴油票点
            this.searchData.piaodian = this.ticket_point_oil;
            break;
          case '2'://LNG票点
            this.searchData.piaodian = this.ticket_point_lng;
            break;
          case '3'://柴油票点成本B
            this.searchData.piaodian = this.ticket_point_oil_b;
            break;
          case '4'://LNG票点成本B
            this.searchData.piaodian = this.ticket_point_lng_b;
            break;
          default:
            this.searchData.piaodian = '';
        }
      },
      hideEdit(){
        this.showStationEdit=false
        // 重新加载页面数据
        this.$refs.table.getLists();
      },
      async initPage(){
        let res = await this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['platform']});
        this.platform = res.data.platform
        let res2 = await this.$commonFun.postProxy('admin/gas/getAllProvinceData',{});
        this.provinceData = res2.data
      },
         async ticketPoint(){
        let res = await this.$commonFun.postProxy('admin/gas/getTicketPoint');
        this.ticket_point_lng = res.data.ticket_point_lng
          this.ticket_point_oil = res.data.ticket_point_oil
          this.ticket_point_lng_b = res.data.ticket_point_lng_b
          this.ticket_point_oil_b = res.data.ticket_point_oil_b
          this.searchData.piaodian = this.ticket_point_oil;//默认是柴油票点
    
      
      },
      async del(info){
        this.$Modal.confirm({
          title:'删除',
          content:`确定要删除站点:${info.gas_name} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/delStation',{station_id:info.station_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })
      },
      async setPiaodian(){
        this.$Modal.confirm({
          title:'批量修改',
          content:`确定要根据筛选条件批量修改吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setPriceByPiaodian',this.searchData);
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })
      },
      async setOpenStock(info,isOpen){
        console.log(typeof isOpen)
        this.$set(info,'is_open_stock',isOpen ? '开启':'关闭')
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setOpenStock',{station_id:info.station_id,isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_open_stock',isOpen ? '开启':'关闭')
            this.$refs.table.getLists();
          }
        })
      },
      async setIsBill(info,isOpen){
        this.$set(info,'is_bill',isOpen ? 1:0)
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setIsBill',{station_id:info.station_id,is_bill:isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_bill',isOpen ? 1:0)
            this.$refs.table.getLists();
          }
        })
      },
      async setIsWithdraw(info,isOpen){
        console.log(typeof isOpen)
        this.$set(info,'is_withdraw',isOpen ? 1:0)
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setIsWithdraw',{station_id:info.station_id,is_withdraw:isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_withdraw',isOpen ? 1:0)
            this.$refs.table.getLists();
          }
        })
      },
      async setIsNeedQppay(info,isOpen){
        this.$set(info,'is_need_qppay',isOpen ? 1:0)
        this.$Modal.confirm({
          content:`确定要设置为 ${isOpen ? '开启' : '关闭'} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/setIsNeedQppay',{station_id:info.station_id,is_need_qppay:isOpen});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            this.$set(info,'is_need_qppay',isOpen ? 1:0)
            this.$refs.table.getLists();
          }
        })
      },
      async changeStationStatus(station_id,old_status){
        this.$Modal.confirm({
          content:`确定要修改状态吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/gas/changeStatus',{station_id:station_id,status:parseInt(old_status)===1 ? -1 : 1});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            // this.$refs.table.getLists();
          }
        })
      },
      async editStationPrice(){
        this.$Modal.confirm({
          render:(h)=>{
            return h( 'Input', {
              props:{value:this.stationChangePrice,size:'large',autofocus: true,type: 'number',},
              on:{
                input:(val)=>{
                  this.stationChangePrice = val;
                }
              }
            })
          },
          loading:true,
          onOk: async ()=>{
            let params = this.searchData;
            params.price = this.stationChangePrice
            let res = await this.$commonFun.postProxy('admin/gas/editStationPriceByMap',params);
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
          onCancel:()=>{
            // this.$Modal.remove()
          }
        })
      },
      editProvince(info){
        this.editProvinceForm.isShow = true
        this.editProvinceForm.station_id = info.station_id
        this.editProvinceForm.title = info.gas_name
        this.editProvinceForm.oldAddress = `${info.province_name} / ${info.city_name} / ${info.county_name}`
        this.editProvinceForm.province = [info.province_code+'',info.city_code+'',info.county_code+'']
        console.log(this.editProvinceForm.province)
      },
      cancelEditProvince(){
        this.editProvinceForm.isShow = false
        this.editProvinceForm.station_id = 0
        this.editProvinceForm.title = ''
        this.editProvinceForm.oldAddress = ''
        this.editProvinceForm.province = []
      },
      async doEditProvince(){
        let params = {
          station_id:this.editProvinceForm.station_id,
          province:this.editProvinceForm.province,
        }
        let res = await this.$commonFun.postProxy('admin/gas/editProvince',params);
        this.cancelEditProvince()
        this.$commonFun.dealApiResult(res)
      },
      async exportStation(){
        try {
          const baseUrl = window.location.origin.replace(/:\d+$/, '');
          const fullUrl = `${baseUrl}/admin/gas/exportStationForBigData`;

          let res = await axios.post(fullUrl, this.searchData, {
            responseType: 'blob',
            timeout: 400000 // 设置超时时间
          });

          // 检查响应状态
          if (res.status === 200) {
            const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              // IE兼容处理
              window.navigator.msSaveOrOpenBlob(blob, '站点信息.csv');
            } else {
              // 现代浏览器处理
              link.href = URL.createObjectURL(blob);
              link.download = '站点信息.csv';
              link.style.display = 'none';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(link.href);
            }
            this.$Message.success('导出成功');
          } else {console.log('后端返回数据失败'+Date.now())
            throw new Error('导出失败');
          }
        } catch (error) {console.log('导出失败失败'+Date.now())
          console.error('导出失败:', error);
          this.$Message.error(error.message || '导出失败');
        }
      },
      async showSetNdrcPrice(){
        //上次设置
        let res = await this.$commonFun.postProxy('admin/gas/getNdrcPriceConfig',{});
        this.ndrcPriceModel.isShow = true;
        this.ndrcPriceModel.prevTime = res.data.dotime
        this.ndrcPriceModel.prevPrice = res.data.price
      },
      async setNdrcPrice(){
        let res = await this.$commonFun.postProxy('admin/gas/setNdrcPrice',this.ndrcPriceModel);
        this.ndrcPriceModel.isLoading = false;
        this.$commonFun.dealApiResult(res,()=>{
          this.ndrcPriceModel.isShow = false
          this.$commonFun.successTip(res.msg)
        })
      },
          timeChange(time) {
        if(time[1].slice(-8)==='00:00:00'){
          time[1] = time[1].slice(0,-8) + '23:59:59'
          this.searchData.create_time = time
        }
      },
      sortChange(data){
        this.searchData.sortKey = data.key
        this.searchData.sortType = data.order
        this.$refs.table.changePage(1)
      },
      resetSort(){
        this.searchData.sortKey = ''
        this.searchData.sortType = ''
        // 通过改变 key 值强制重新创建表格组件，清除所有排序状态
        this.tableKey++
        this.$nextTick(() => {
          this.$refs.table.changePage(1)
        })
      },
      async updateStation(station_id, gas_id, platform,station_type){
        this.$Modal.confirm({
          title: '更新',
          content: '确定要更新该站点吗？',
          loading: true,
          onOk: async () => {
            let res = await this.$commonFun.postProxy('admin/gas/updateStation', { station_id, gas_id, platform,station_type });
            this.$Modal.remove();
            this.$commonFun.dealApiResult(res, () => {
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            });
          },
          onCancel: () => {
            this.$Modal.remove();
          }
        });
      },
      // 新增：打开重复站点详情并加载数据
      async showDuplicates(station_id){
        this.duplicateModal.isShow = true;
        this.duplicateModal.loading = true;
        this.duplicateModal.station_id = station_id;
        this.duplicateModal.list = [];
        try {
          let res = await this.$commonFun.postProxy('admin/gas/getDuplicateStations', { station_id });
          this.duplicateModal.loading = false;
          this.$commonFun.dealApiResult(res, () => {
            // 假设接口返回数组在 res.data
            this.duplicateModal.list = res.data || [];
          });
        } catch (e) {
          this.duplicateModal.loading = false;
          this.duplicateModal.list = [];
        }
      },

      closeDuplicateModal(){
        this.duplicateModal.isShow = false;
        this.duplicateModal.loading = false;
        this.duplicateModal.station_id = null;
        this.duplicateModal.list = [];
      },

      // 打开油品弹窗并加载列表
      async showProducts(station_id, stationName){
        this.productModal.isShow = true;
        this.productModal.isLoading = true;
        this.productModal.station_id = station_id;
        this.productModal.title = `油品设置 - ${stationName || station_id}`;
        this.productModal.list = [];
        try{
          await this.loadProducts();
        }catch(e){
          this.productModal.isLoading = false;
          this.productModal.list = [];
        }
      },

      // 取消并关闭弹窗
      cancelProductModal(){
        this.productModal.isShow = false;
        this.productModal.isLoading = false;
        this.productModal.station_id = 0;
        this.productModal.list = [];
      },

      // 拉取油品列表，并生成基于默认 oilOptions 的完整列表（已启用/未启用）
      async loadProducts(){
        let res = await this.$commonFun.postProxy('admin/gas/getStationProducts',{station_id: this.productModal.station_id});
        this.productModal.isLoading = false;
        this.$commonFun.dealApiResult(res, ()=>{
          let arr = res.data || [];
          let existMap = {};
          arr.forEach(item=>{
            let key = item.oil_no_name || item.oil_name || String(item.oil_no || '');
            if(!key) return;
            existMap[key] = item;
          });
          this.productModal.list = this.oilOptions.map(opt => {
            let found = existMap[opt.label];
            if(found){
              return {
                id: found.gun_id || found.id || null,
                oil_no: found.oil_no !== undefined ? found.oil_no : (opt.id || ''),
                oil_no_name: opt.label,
                enabled: true,
                price: found.price === undefined ? '' : found.price,
                price2: found.price2 === undefined ? '' : found.price2,
                station_price: found.station_price === undefined ? '' : found.station_price,
                no_bill_price: found.no_bill_price === undefined ? '' : found.no_bill_price,
                ndrc_price: found.ndrc_price === undefined ? '' : found.ndrc_price,
              }
            }else{
              return {
                id: null,
                oil_no: opt.id,
                oil_no_name: opt.label,
                enabled: false,
                price: '',
                price2: '',
                station_price: '',
                no_bill_price: '',
                ndrc_price: '',
              }
            }
          });
        })
      },

      // 切换启用/禁用 --- 仅修改响应式数据，标记为待保存
      toggleProductEnable(row, val){
        this.$set(row, 'enabled', !!val);
        // 可选标记，表示状态已修改但尚未保存
        this.$set(row, '_statusPending', true);
      },

      // 保存某行（新增或编辑）——保存时把 status 作为参数发送到后端
      async saveRow(row){
        if(!row.oil_no_name){
          this.$Message.error('请选择油品');
          return;
        }
        // 使用预设 oilOptions 的 id 作为 oil_no 优先值
        let opt = this.oilOptions.find(o => o.label === row.oil_no_name);
        let oil_no_val = opt ? opt.id : row.oil_no;

        let payload = {
          station_id: this.productModal.station_id,
          oil_no: oil_no_val,
          oil_no_name: row.oil_no_name || '',
          price: row.price === '' ? '' : Number(row.price),
          price2: row.price2 === '' ? '' : Number(row.price2),
          station_price: row.station_price === '' ? '' : Number(row.station_price),
          no_bill_price: row.no_bill_price === '' ? '' : Number(row.no_bill_price),
          ndrc_price: row.ndrc_price === '' ? '' : Number(row.ndrc_price),
          status: row.enabled ? 1 : 0, // 将启用状态作为 status 发送
        };
        try{
          if(row.id){
            payload.id = row.id;
            let res = await this.$commonFun.postProxy('admin/gas/editStationProduct', payload);
            this.$commonFun.dealApiResult(res, ()=>{
              this.$Message.success(res.msg || '保存成功');
              this.loadProducts();
            })
          }else{
            let res = await this.$commonFun.postProxy('admin/gas/addStationProduct', payload);
            this.$commonFun.dealApiResult(res, ()=>{
              this.$Message.success(res.msg || '新增成功');
              this.loadProducts();
            })
          }
        }catch(e){
          // 可选错误处理
        }
      },
    },
    mounted() {
      // 线路匹配（groupID==9）不展示“类型”和“站点价格”列
      if (parseInt(sessionStorage.getItem('groupID')) === 9) {
        this.tableColumn = this.tableColumn.filter(col => !['类型', '站点价格','待结算'].includes(col.title));
      }
      this.initPage();
      this.ticketPoint();
      
      // 处理 URL 参数，自动填充筛选条件
      if (this.$route.query.station_id) {
        this.searchData.station_id = this.$route.query.station_id;
        // 清除状态筛选，显示所有状态的站点
        this.searchData.status = '';
        // 延迟执行搜索，确保页面加载完成
        this.$nextTick(() => {
          this.$refs.table.searchAndResetPage();
        });
      }
    },
  }
</script>

<style scoped>
/* 重复站点价格标红样式 */
.price-warning {
  color: #ff4d4f;
  font-weight: 600;
}
</style>
